import React, {Component, useState, useEffect } from 'react';
import { Message } from "element-react";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import '../Detail/detail.scss';
import $ from 'jquery';
import classNames from 'classnames';
import API from './../../config/api';
import {Toast} from 'antd-mobile';
import DetailText from './Detail/detail';
import Video from './Video/video';
import Imagesay from './Imagesay/imagesay';
import Audio from './Audio/audio';
// @connect(
//   state => ({admin: state.admin}),
//   {refresh_admin}
// )
var setin = null;
class Preview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      data: {},
      type: '',
      curSwiperText: '',
      curSwiperIndex: 1,
      name: '',
      playSpeedAry:['1','1.25','1.5','2'], // 播放速度
      curSelectSpeed:'', // 当前选择的倍数
      audioPlayStatus:false,
      audioDuration:'', // 音频总时长
      audioCurTime:0,
      //notStarted：未开始 start：开始 suspend：暂停 end：结束
      stateName: 'notStarted',
      playerName: '',
      videoPlayer: null, //新增解决视频不刷新的问题（跳转后视频还在播放）
      titleSwitch: false,
      show: false, //描述展开收起
      recommendList: [], //相关推荐列表
      showElem: true,
      duration: props.duration,
      formattedDuration: '',
    };

  }

  componentWillMount() {
    const {uuid} = this.props.match.params;
    this.setState({
      uuid,
    }, () => {
      this.getContent()
    })
    
  }

  componentDidMount() {
  }
  // 路由的参数由于是在componentDidMount中获取的，如果在详情页面再次打开详情页面，由于组件并没有重新渲染，导致didMount不会获取路由参数。
  // 因此在参数改变的时候，可以利用componentWillReceiveProps来更新变量。
  //组件更新时被调用
  componentWillReceiveProps(newProps) {
    const newUuid = newProps.match.params.uuid;
    if (newUuid !== this.state.uuid) {
      this.setState({
        uuid: newUuid,
      }, () => {
        this.getContent()
      })
    }
  }

  componentWillUnmount() {
  }
  getContent() {
    let _this = this
     $.ajax({
      type: 'get',
      url: API.preview_detail,
      async: false,
      data: {
        uuid: this.state.uuid,
      },
     }).done((res) => {
      console.log('preview接口返回：', res)
      if(res.code == 0){
        this.setState({
          type: res.data.type,
          data: res.data
        }, () => {
          
          })
      } else if(res.code == -1){
        return
      } else {
        Toast.fail(res.msg || res.error);
        return
      }
     })
  }
  
  render() {
    const {data, type, audioDuration, audioCurTime, audioPlayStatus, playSpeedAry, curSelectSpeed} = this.state;
    console.log(type)
    return (
      <div className="detail-box">
        {type == 1 ? (
          <DetailText key={data.uuid} data={data}/>
        ) : type == 2 ? (
          <Video key={data.uuid} data={data}/>
        ) : type == 4 ? (
          <Imagesay key={data.uuid} data={data}/>
        ) : type ==  21 ? (
          <Audio key={data.uuid} data={data}/>
        ) : <div style={{height:'100vh', display:'flex', justifyContent:'center', alignItems:'center', backgroundColor:'#f5f5f5', fontSize:'16px'}}>内容不存在</div>}
      </div>
    );
  }
}

export default Preview;


// WEBPACK FOOTER //
// ./src/pages/Preview/preview.js